module.exports = __webpack_public_path__ + "img/654252cd1841d841536ac6488b2bbaf6.jpg";